module.exports = __webpack_public_path__ + "img/iconAttendance.1043ccc8.png";